export default __webpack_public_path__ + "static/media/bannerCrisBarros.56b7fa58.svg";